"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSourceParam = void 0;
function getSourceParam($location) {
    var source = $location.search().source;
    return source ? "?source=".concat(source) : "";
}
exports.getSourceParam = getSourceParam;
